class SubmittableFragmentContext {
    constructor() {
        this.cancelListeners = new Set();
        this.submitListeners = new Set();
    }
    addCancelListener(listener) {
        if (this.cancelListeners.has(listener)) {
            throw new Error('[SubmittableFragmentContext]: Cancel listener already registered.');
        }
        this.cancelListeners.add(listener);
        return () => {
            this.cancelListeners.delete(listener);
        };
    }
    addSubmitListener(listener) {
        if (this.submitListeners.has(listener)) {
            throw new Error('[SubmittableFragmentContext]: Submit listener already registered.');
        }
        this.submitListeners.add(listener);
        return () => {
            this.submitListeners.delete(listener);
        };
    }
    cancel(event) {
        this.cancelListeners.forEach(fn => fn(event));
    }
    submit(event) {
        this.submitListeners.forEach(fn => fn(event));
    }
    destroy() {
        this.cancelListeners.clear();
        this.submitListeners.clear();
    }
}
export { SubmittableFragmentContext, };
//# sourceMappingURL=submittable-fragment-context.js.map